import { Grid } from '@mui/material';
import SelectField from 'components/select-field';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { DatesAndConfigurationForm, validateAdditionalFeesLetter } from '../services';
import Title from './title';

const additionalFeesLetterOptions = [
  { name: 'B', text: 'B' },
  { name: 'C', text: 'C' },
];

const AdditionalFees: FC = () => {
  const { t } = useTranslation();
  const { control, watch } = useFormContext<DatesAndConfigurationForm>();
  const [transactionType] = watch(['transaction_type']);

  if (!validateAdditionalFeesLetter.includes(transactionType)) return null;

  return (
    <Grid container direction="column" wrap="nowrap" spacing={2}>
      <Grid item xs={12}>
        <Title>{t('datesAndConfig:additionalFees')}</Title>
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name="additional_fees_letter"
          render={({ field }) => (
            <SelectField
              value={field.value}
              inputRef={field.ref}
              label={t('datesAndConfig:additionalFeesLetter')}
              emptyValue={false}
              data={additionalFeesLetterOptions}
              dataKey="name"
              dataValue="name"
              dataText="text"
              handleBlur={field.onBlur}
              handleChange={(event) => field.onChange(event.target.value)}
            />
          )}
        />
      </Grid>
    </Grid>
  );
};

export default AdditionalFees;
